import CreateUpdateStreetLightView from "./CreateUpdateStreetLightView/CreateUpdateStreetLightView";

import { useSinglePlanBT} from "../../../hooks";
import { withCreateUpdateStreetLightForm } from "../../../streetLight/withCreateUpdateForm";

export default function CreateUpdateStreetLightPresenter({
  isUpdate,
}: {
  isUpdate?: boolean;
}) {

  const {singlePlanBTQuery} = useSinglePlanBT();
  const From = withCreateUpdateStreetLightForm(
    CreateUpdateStreetLightView,
    singlePlanBTQuery.data?.plan_id || null,
    null,
    isUpdate
  );

  return <From />;
}
